import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./service.css";

function ServicePrintSent() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="service-panel">
            <div className="service-scroll"><section className="service-card service-empty">
                <span className="service-badge">{t("service.sent.badge")}</span>
                <h1 className="service-title">{t("service.sent.title")}</h1>
                <p className="service-subtitle">{t("service.sent.wait")}</p>
                <p className="service-subtitle">{t("service.sent.check")}</p>
                <div className="service-actions w-full">
                    <button data-analytics="serviceprintsent.service.to_documents.1" onClick={() => navigate("/printing/show_list/user", { replace: true })} className="service-button primary">{t("service.to_documents")}</button>
                    <button data-analytics="serviceprintsent.service.sent.service.2" onClick={() => navigate("/service", { replace: true })} className="service-button">{t("service.sent.service")}</button>
                </div>
            </section>
            </div>
        </div>
    );
}

export default ServicePrintSent;
